(function(){
     'use strict';

     angular
        .module('app')
        .factory('GenerallabService', GenerallabService);

    GenerallabService.$inject = ['$http'];

    function GenerallabService($http){

        var service = {

        	centro:{},
        	numAsesoramientosCentro:0,
           	optionsProvincias: {
	        	ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/ajax/getprovincias",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsSexo: {
	        	ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/ajax/getsexos",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        doStuff:doStuff,
	        optionsCastrado: {
	        	ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/ajax/getcastrado",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsEspecie: {
	        	ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/ajax/getespecie",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsRaza: {
	        	ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/ajax/getrazas",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        }
        };

        function doStuff(date) {
	        console.log(date);
	    }

        return service;
 		

    }
})();